module.exports = __webpack_public_path__ + "static/media/emalec.52e8327d.png";